import { ChangeDetectionStrategy, Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { ConfigEditorConfirmationDialogViewModel, ConfigEditorConfirmationPhase } from './config-editor-confirmation-dialog.view-model';

@Component({
  selector: 'osn-cxb-config-editor-confirmation-dialog',
  templateUrl: './config-editor-confirmation-dialog.component.html',
  styleUrls: ['./config-editor-confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigEditorConfirmationDialogComponent {
  @ViewChild(DialogComponent) private readonly dialog: DialogComponent;
  public phase: ConfigEditorConfirmationPhase = ConfigEditorConfirmationPhase.First;
  public readonly confirmKey: string;
  public readonly title: string;
  public readonly warningText: string;
  public readonly actionText: string;
  public readonly keyCtrl: UntypedFormControl;
  public readonly ConfigEditorConfirmationPhase = ConfigEditorConfirmationPhase;
  private readonly endPhase: ConfigEditorConfirmationPhase;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfigEditorConfirmationDialogViewModel) {
    this.confirmKey = data?.confirmKey;
    this.title = data?.title;
    this.warningText = data?.warningText;
    this.actionText = data?.actionText;
    this.endPhase = data?.endPhase || ConfigEditorConfirmationPhase.Second;
    this.keyCtrl = new UntypedFormControl('', [Validators.required, Validators.pattern(this.confirmKey)]);
  }

  public onSaveClick(): void {
    if (this.endPhase === ConfigEditorConfirmationPhase.First) {
      this.onConfirmClick();
      return;
    }
    this.phase = ConfigEditorConfirmationPhase.Second;
  }

  public onCancelClick(): void {
    this.dialog.closeDialog();
  }

  public onConfirmClick(): void {
    this.closeDialog(true);
  }

  public onConfirmCancelClick(): void {
    this.dialog.closeDialog();
  }

  private closeDialog(result: unknown): void {
    this.dialog.closeDialog(result);
  }
}
